import React, { ReactElement } from 'react';

import { HeaderContent } from '../../lib/api/types';

export interface ErrorProps {
    errorCode: number;
    errorMessage: string;
}

export function Error({ errorCode, errorMessage }: ErrorProps): ReactElement {
    return (
        <div data-zta="header-error">
            <h1>
                An error occured, Error {errorCode}: {errorMessage}
            </h1>
            <style jsx global>
                {`
                    body {
                        display: block;
                    }
                `}
            </style>
        </div>
    );
}

export function isErrorProps(
    value: HeaderContent | ErrorProps,
): value is ErrorProps {
    return (value as ErrorProps)?.errorCode !== undefined;
}
